import { SDK } from '../helpers/sdk';
import type { JobTypes } from '@sda/enums';
import type { GenericMetadata } from '@sda/helpers/helpers.types';
import type { FirestoreClientData } from '../interfaces';
import type { Job } from '@sda/interfaces/queue/job';

/**
 * SDK Class to interact with Firestore Jobs Queue
 */
export class Jobs extends SDK<Job> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient);

    this.collection = this.fsh.Schema.JobsQueue;
  }

  /**
   * Add a job request to the queue
   * @return {Promise<any>}
   */
  addJob(requestedForDate: Date, metadata: GenericMetadata, jobType: JobTypes): Promise<string> {
    return this.create({
      metadata,
      jobType,
      requestedFor: requestedForDate,
      processedAt: null,
      errorCode: null,
    });
  }
}
